import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';

export default function DialogForEdge() {
    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Ihre Version von Edge unterstützt diese Seite nicht vollständig"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Wechseln Sie gegebenenfalls zu einem anderen Browser
          </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Link href='https://www.google.com/chrome/'>
                        <Button onClick={handleClose} color="primary">
                            Chrome Download
                        </Button>
                    </Link>
                    <Link href='https://www.mozilla.org/de/firefox/new/'>
                        <Button onClick={handleClose} color="primary">
                            Firefox Download
                        </Button>
                    </Link>
                    <Button onClick={handleClose} color="primary">
                        Abbrechen
                        </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}
